/**
 * Submit Record Page
 *
 * Create form for a new entity record.
 */

import { Typography, useI18n } from '@ops-matrix/design-system-ui';
import { useNavigate, useParams } from 'react-router-dom';
import EntityRecordForm from '../../components/entity/EntityRecordForm';
import { PageTemplate } from '../../components/layout/PageTemplate';

export default function SubmitRecordPage() {
  const { entityId } = useParams<{ entityId: string }>();
  const navigate = useNavigate();
  const { t } = useI18n();

  if (!entityId) {
    return (
      <PageTemplate variant="form">
        <Typography color="error" sx={{ textAlign: 'center', py: 4 }}>
          {t('consumer.entity.entityTypeNotSpecified')}
        </Typography>
      </PageTemplate>
    );
  }

  const handleSuccess = (record: { id: string }) => {
    navigate(`/records/${entityId}/${record.id}`);
  };

  const handleCancel = () => {
    navigate(`/records/${entityId}`);
  };

  return (
    <PageTemplate variant="form">
      <EntityRecordForm entityId={entityId} mode="create" onSuccess={handleSuccess} onCancel={handleCancel} />
    </PageTemplate>
  );
}
